import { create, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { getTokenSilent } from '../libs/auth';

export const microsoftGraphServiceApiClient = create({
  baseURL: process.env.REACT_APP_MS_GRAPH_ENDPOINT,
  headers: {
    'Content-type': 'application/json'
  }
});

microsoftGraphServiceApiClient.interceptors.request.use(
  async (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> => {
    const tokenResponse = await getTokenSilent();

    if (tokenResponse && config.headers) {
      config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

const profile = async (config?: AxiosRequestConfig) =>
  microsoftGraphServiceApiClient.get('/me', config);

const organizationMembers = async (orgId: string, config?: AxiosRequestConfig) =>
  microsoftGraphServiceApiClient.get(
    `/groups/${orgId}/transitiveMembers/microsoft.graph.user`,
    config
  );

const organizationId = async (config?: AxiosRequestConfig) =>
  microsoftGraphServiceApiClient.get(
    `/me/transitiveMemberOf/microsoft.graph.group?$select=id,${process.env.REACT_APP_ORG_GROUP_EXTENSION_ID}`,
    config
  );

const MicrosoftGraphService = {
  organizationMembers,
  organizationId,
  profile
};

export default MicrosoftGraphService;
